import React, { useState } from 'react';
import { BiddingItemJson } from 'store/modules/bidding_store/types';
import { Container } from './styles';

interface AiManagementBiddingItemsProps {
  items: BiddingItemJson[];
}

const formatCurrency = (value: number) =>
  (value || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

const AiManagementBiddingItems: React.FC<AiManagementBiddingItemsProps> = ({ items }) => {
  const [search, setSearch] = useState('');
  const [collapsed, setCollapsed] = useState(false);

  const query = search.trim().toLowerCase();
  const filtered = query
    ? items.filter(
        (item) =>
          item.descricao?.toLowerCase().includes(query) ||
          item.numero_item?.toString().includes(query),
      )
    : items;

  return (
    <Container className="card border mt-4">
      <button
        type="button"
        className="items-header card-header d-flex align-items-center justify-content-between"
        onClick={() => setCollapsed((value) => !value)}
        aria-expanded={!collapsed}
      >
        <span className="d-flex align-items-center font-weight-bold">
          <i className="material-icons mr-2">list_alt</i>
          Itens
        </span>
        <i className="material-icons">{collapsed ? 'expand_more' : 'expand_less'}</i>
      </button>

      {!collapsed && (
        <div className="card-body">
          <div className="d-flex justify-content-end mb-3">
            <div className="items-search d-flex align-items-center">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por item"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
              />
              <button
                type="button"
                className="btn btn-link p-0 text-primary flex-shrink-0"
                onClick={() => setSearch('')}
              >
                Limpar
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table items-table mb-0">
              <thead>
                <tr>
                  <th className="text-center item-cell">Item</th>
                  <th className="desc-cell">Descrição</th>
                  <th className="text-center qnt-cell">Qnt.</th>
                  <th className="text-right text-nowrap">Valor unitário</th>
                  <th className="text-right text-nowrap">Valor total</th>
                  <th className="text-right text-nowrap">Valor estimado</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={6} className="text-center text-secondary py-3">
                      Nenhum item encontrado.
                    </td>
                  </tr>
                )}
                {filtered.map((item) => (
                  <tr key={`${item.numero_item}-${item.numero_lote ?? 'sl'}`}>
                    <td className="text-center">{item.numero_item}</td>
                    <td className="desc-cell">{item.descricao}</td>
                    <td className="text-center">{item.quantidade}</td>
                    <td className="text-right text-nowrap">
                      {formatCurrency(item.valor_unitario)}
                    </td>
                    <td className="text-right text-nowrap font-weight-bold">
                      {formatCurrency(item.valor_total)}
                    </td>
                    <td className="text-right text-nowrap">
                      {formatCurrency(item.valor_estimado)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Container>
  );
};

export default AiManagementBiddingItems;
